export const AVAILABLE_RETAILER_SIGNUP_STEPS = {
    'retailer-signup-company-details': {
        progress: 1,
        trackingStepName: 'Retailer Signup Step 1 completed - Company details',
        title: 'labels.company_details',
        subtitle: 'labels.provide_company_details',
        icon: 'far fa-rocket-launch',
    },
    'retailer-signup-choose-company': {
        progress: 2,
        trackingStepName: 'Retailer Signup Step 2 completed - Choose a company',
        title: 'labels.company_details',
        subtitle: 'labels.choose_company_from_list',
        icon: 'far fa-rocket-launch',
    },
    'retailer-signup-store-about': {
        progress: 3,
        trackingStepName: 'Retailer Signup Step 3 completed - Store about',
        title: 'labels.about_store',
        subtitle: 'labels.how_describe_store',
        icon: 'far fa-store',
    },
    'retailer-signup-company-about': {
        progress: 4,
        trackingStepName:
            'Retailer Signup Step 4 completed - Company about in depth details',
        title: 'labels.company_details',
        subtitle: 'labels.tell_about_company',
        icon: 'far fa-rocket-launch',
    },
    'retailer-signup-user-details': {
        progress: 5,
        trackingStepName: 'Retailer Signup Step 5 completed - User details',
        title: 'signup-modal.heading.step3',
        subtitle: 'labels.provide_name_and_email',
        icon: 'far fa-user',
    },
}

export const SIGNUP_STATUSES_MAP = {
    STEP_1: 'company-details',
    STEP_2: 'choose-company',
    STEP_3: 'store-about',
    STEP_4: 'company-about',
    STEP_5: 'user-details',
}

export const STORETYPES = [
    { icon: 'far fa-home fa-lg', value: 'HOME_DECO' },
    { icon: 'far fa-gifts fa-lg', value: 'CONCEPT_GIFTS' },
    { icon: 'far fa-baby-carriage', value: 'BABY_KIDS' },
    { icon: 'far fa-tshirt', value: 'CLOTHING_SHOES_STORE' },
    { icon: 'far fa-sparkles', value: 'BEAUTY_HAIR_SALON_SPA' },
    { icon: 'far fa-swatchbook', value: 'PROFESSIONAL_SERVICES' },
    { icon: 'far fa-gem', value: 'ACCESSORIES_JEWELRY' },
    { icon: 'far fa-croissant', value: 'FOOD_BEVERAGE_STORE' },
    { icon: 'far fa-flower-tulip', value: 'FLORIST_GARDEN_OUTDOOR_STORE' },
    { icon: 'far fa-file-medical', value: 'BEAUTY_STORE_DRUGSTORE_PHARMACY' },
    { icon: 'far fa-hotel', value: 'HOTEL_GUEST_HOUSE_CATERING' },
    { icon: 'far fa-books', value: 'STATIONERY_BOOKS' },
    { icon: 'far fa-shopping-basket', value: 'CONVENIENCE_STORE' },
    { icon: 'far fa-volleyball-ball', value: 'SPORT_LEISURE_STORE' },
    { icon: 'far fa-dog', value: 'PET_STORE' },
    { icon: 'far fa-utensils', value: 'KITCHEN_COOKING_STORE' },
]

export const STORES_TYPES = [
    {
        icon: 'far fa-store',
        value: 'offline_only',
        label: 'labels.physical_store',
    },
    {
        icon: 'far fa-globe',
        value: 'online_only',
        label: 'labels.online_store',
    },
    { icon: 'far fa-laptop-house', value: 'omnichannel', label: 'labels.both' },
    {
        icon: 'far fa-user-tie',
        value: 'professional_services',
        label: 'labels.professional_services',
    },
]

export const COMPANY_SETTINGS_DEFAULT = {
    entityName: 'placeholders.entity_name',
    vModelName: 'registeredCompanyName',
    vatFields: {
        vat: 'placeholders.vat_number',
        coc: 'placeholders.coc_number',
    },
}

export const COMPANY_SETTINGS = {
    default: { ...COMPANY_SETTINGS_DEFAULT },
    BE: {
        ...COMPANY_SETTINGS_DEFAULT,
        vatFields: { vat: 'placeholders.vat_number' },
    },
    DE: {
        ...COMPANY_SETTINGS_DEFAULT,
        vatFields: {
            coc: 'placeholders.handelsregister_number',
            vat: 'placeholders.vat_number',
        },
    },
    NL: {
        ...COMPANY_SETTINGS_DEFAULT,
        vatFields: {
            coc: 'placeholders.coc_number',
            vat: 'placeholders.vat_number',
        },
    },
    ES: {
        ...COMPANY_SETTINGS_DEFAULT,
        vatFields: {
            coc: 'placeholders.cif_number',
            vat: 'placeholders.vat_number',
        },
    },
    FR: {
        ...COMPANY_SETTINGS_DEFAULT,
        vatFields: {
            coc: 'placeholders.siren_number',
            vat: 'placeholders.vat_number',
        },
    },
    GB: {
        ...COMPANY_SETTINGS_DEFAULT,
        vatFields: {
            coc: 'placeholders.coc_number',
            vat: 'placeholders.vat_number',
        },
    },
}
